import React from "react"

import LoadingIndicator from "./indicator"

const staticIndicator = (
  <LoadingIndicator global={true}>Loading...</LoadingIndicator>
)

export default staticIndicator
